<template>
  <div>
    <div
      @mousedown.stop
      @touchend.stop
      class="w-rounded-t-2xl w-h-50px w-flex w-items-center w-cursor-default"
      style="box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.2);transition: width 0.25s;"
      :style="{ width: !isPlay ? '48.5px' : '335px' }">
      <div
        class="w-flex w-flex-col w-items-center w-w-58px w-cursor-pointer w-flex-shrink-0"
        style="zoom: 0.8;transform: translateX(2.5px);"
        @click="play"
        v-show="!isPlay || isPause">
        <img _w="20px" src="@/assets/tool/play.svg" />
        <div class="w-mt-4px" _text="12px">播放</div>
      </div>
      <div
        class="w-flex w-flex-col w-items-center w-w-58px w-cursor-pointer w-flex-shrink-0"
        style="zoom: 0.8;transform: translateX(2.5px);"
        v-show="isPlay && !isPause"
        @click="pause">
        <img _w="11px" src="@/assets/tool/pause.svg" />
        <div class="w-mt-6px" _text="12px">暂停</div>
      </div>
      <div
        class="w-transform w-translate-y-[-1px] w-flex w-flex-col w-items-center w-w-58px w-cursor-pointer w-flex-shrink-0"
        style="zoom: 0.8;transform: translateX(-6px);"
        v-show="isPlay"
        @click="stop">
        <img _w="20px" src="@/assets/tool/stop.svg" />
        <div class="w-mt-4px" _text="12px">停止</div>
      </div>
      <div class="w-text-12px w-text-[#959595] w-flex-shrink-0" style="zoom: 0.75;" v-show="isPlay">
        {{ secondFormat(time.current) }}
      </div>
      <div
        ref="progressElement"
        class="w-w-140px w-h-4px w-rounded-full w-overflow-hidden w-mx-8px w-flex-shrink-0 w-cursor-pointer"
        :style="{ background: !isDrag ? '#FF5E2A' : '#E6E6E6' }"
        @pointerdown="start"
        @pointerup="jumpTo"
        v-if="isPlay">
        <div
          class="w-w-full w-h-full w-pointer-events-none"
          :style="{ transform: `translateX(${currentProgress}%)`, background: isDrag ? '#FF5E2A' : '#E6E6E6' }" />
      </div>
      <div class="w-text-12px w-text-[#959595] w-flex-shrink-0" style="zoom: 0.75;" v-show="isPlay">
        {{ secondFormat(time.duration) }}
      </div>
      <div v-if="isPlay" class="w-relative">
        <div v-if="showSlider" _pos="absolute" _top="[-100px]" _z="999" _border="rounded-[10px]"
          :style="{
            transform: `translateX(calc(-50% + 13px))`,
            'box-shadow': 'rgba(0, 0, 0, 0.1) 0px 0px 5px 2px',
            padding: '10px 0'
          }"
        >
          <el-slider
            :show-tooltip="false"
            v-model="volume"
            @change="changeVolume"
            :vertical="true"
            height="100px"
            style="zoom:0.7"
          />
        </div>
        <img
          ref="slide"
          @pointerup.stop
          @click="showSlider = !showSlider"
          class="w-cursor-pointer w-w-15px w-ml-8px w-mr-15px w-flex-shrink-0"
          src="@/assets/tool/sound.svg" />
      </div>
    </div>
    <audio
      ref="audioElement"
      @play=";(isPlay = true), (isPause = false)"
      @pause="isPause = true"
      @ended="stop"
      :src="musicPath"
      @canplay="canPlay = true"
      @timeupdate="onTimeUpdate"
      @loadedmetadata="loadedmetadata"
      :autoplay="false" />
  </div>
</template>

<script>
export default {
  name: 'CustomAudio',
  props: {
    musicPath: String,
    playTime: Number,
    stopEvent: Function
  },
  data() {
    return {
      isDrag: false,
      isPlay: false,
      isPause: false,
      time: {
        duration: 0,
        current: 0
      },
      percentage: 0,
      showSlider: false, //音量滑块
      volume: 0 //音量大小
    }
  },
  watch: {
    playTime: {
      handler(val) {
        if (val != null) {
          this.$refs.audioElement.currentTime = val
          if (this.isPause) {
            this.play()
          } else {
            this.pause()
            this.play()
          }
        }
      },
    }
  },
  computed: {
    currentProgress() {
      if (this.isDrag) {
        return this.percentage * 100 - 100
      }
      return (this.time.current / this.time.duration) * 100
    }
  },
  methods: {
    changeVolume(volume) {
      this.$refs.audioElement.volume = volume / 100
    },
    start(e) {
      const element = this.$refs.progressElement
      if (element instanceof HTMLDivElement && element && this.$refs.audioElement) {
        const clickX = e.clientX
        const offsetX = clickX - element.getBoundingClientRect().left
        let per = offsetX / element.getBoundingClientRect().width
        per = per < 0 ? 0 : per > 1 ? 1 : per
        this.percentage = per
      }
      this.isDrag = true
      document.addEventListener('pointermove', this.move)
      document.addEventListener('pointerup', this.jumpTo)
    },
    move(e) {
      if (!this.isDrag) return
      const element = this.$refs.progressElement
      if (element instanceof HTMLDivElement && element && this.$refs.audioElement) {
        const clickX = e.clientX
        const offsetX = clickX - element.getBoundingClientRect().left
        let per = offsetX / element.getBoundingClientRect().width
        per = per < 0 ? 0 : per > 1 ? 1 : per
        this.percentage = per
      }
    },
    jumpTo(e) {
      const element = this.$refs.progressElement
      if (element instanceof HTMLDivElement && element && this.$refs.audioElement) {
        const clickX = e.clientX
        const offsetX = clickX - element.getBoundingClientRect().left
        const percentage = offsetX / element.getBoundingClientRect().width
        this.$refs.audioElement.currentTime = percentage * this.$refs.audioElement.duration
      }
      this.removeMoveEventListener()
    },
    removeMoveEventListener() {
      document.removeEventListener('pointermove', this.move)
      document.removeEventListener('pointerup', this.jumpTo)
      this.isDrag = false
    },
    play() {
      if (!this.$refs.audioElement) return
      this.$refs.audioElement.play()
      this.isPlay = true
      this.isPause = false
    },
    pause() {
      if (!this.$refs.audioElement) return
      this.$refs.audioElement?.pause()
    },
    stop() {
      if (!this.$refs.audioElement) return
      this.$refs.audioElement.pause()
      this.$refs.audioElement.currentTime = 0
      this.isPlay = false
      this.isPause = false
      this.showSlider = false
      this.stopEvent()
    },
    onTimeUpdate() {
      this.time.current = this.$refs.audioElement?.currentTime ?? 0
      this.$emit('getCurrent', this.time.current)
    },
    loadedmetadata() {
      this.time.duration = this.$refs.audioElement?.duration ?? 0
      this.volume = this.$refs.audioElement?.volume * 100 ?? 0
    },
    secondFormat(seconds) {
      const times = []
      if (seconds >= 60 * 60) {
        const hour = parseInt(((seconds / 60) * 60).toString())
        times.push(hour < 10 ? `0${hour}` : hour.toString())
        seconds = seconds % (60 * 60)
      }
      if (seconds >= 60) {
        const minute = parseInt((seconds / 60).toString())
        times.push(minute < 10 ? `0${minute}` : minute.toString())
        seconds = seconds % 60
      }
      else {
        times.push('00')
      }
      if (seconds > 0) {
        times.push(seconds < 10 ? `0${Math.floor(seconds)}` : Math.floor(seconds))
      }
      else {
        times.push('00')
      }
      return times.join(':')
    }
  }
}
</script>

